import { Trans, useTranslation } from 'react-i18next';
import classes from './Conditioning.module.scss';
import image_01 from '../../../assets/img/Portfolio/Conditioning/image_01.avif';
import image_02 from '../../../assets/img/Portfolio/Conditioning/image_02.avif';

const Conditioning = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.titleWrap}>
                    <h2 className={`${classes.title} font-48`}>
                        <Trans>
                            {t('portfolio.conditioning.title')}
                        </Trans>
                    </h2>
                </div>
                <div className={classes.head}>
                    <p className={`${classes.text_01} font-20`}>
                        {t('portfolio.conditioning.text_01')}
                    </p>
                    <p className={`${classes.text_02} font-16`}>
                        {t('portfolio.conditioning.text_02')}
                    </p>
                </div>
                <div className={classes.blocks}>
                    <div className={`${classes.block} ${classes.block_01}`}>
                        <div>
                            <img className={classes.image} src={image_01} alt='' />
                            <img className={`${classes.image} ${classes.imageMob}`} src={image_02} alt='' />
                        </div>
                        <div>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t('portfolio.conditioning.block_01.subtitle')}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t('portfolio.conditioning.block_01.desc')}
                            </p>
                        </div>
                    </div>
                    <div className={`${classes.block} ${classes.block_02}`}>
                        <div>
                            <h4 className={`${classes.subtitle} font-20`}>
                                {t('portfolio.conditioning.block_02.subtitle')}
                            </h4>
                            <p className={`${classes.desc} font-16`}>
                                {t('portfolio.conditioning.block_02.desc')}
                            </p>
                        </div>
                        <img className={classes.image} src={image_02} alt='' />
                    </div>
                </div>
                <div className={classes.bottom}>
                    <div className={classes.line}></div>
                    <p className={`${classes.text} font-16`}>
                        {t('portfolio.conditioning.info')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Conditioning;
